import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPageBackIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 15,
			r: 14.5,
			fill: "white",
			stroke: "#C6CCDA"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.2071 9.08569L17.6213 10.4999L13.3284 14.7928L17.6213 19.0857L16.2071 20.4999L10.5 14.7928L16.2071 9.08569Z",
			fill: "#757783"
		})
	]
});
const ForwardRef = forwardRef(SvgPageBackIcon);
export default ForwardRef;
